module.exports = __webpack_public_path__ + "static/img/yushan-logo.6b21c512.png";